import { z } from 'zod';
/**
 * Контракты модуля `jobs` (M10-light).
 * Job-система: фоновые задачи с прогрессом, отменой и recovery.
 * См. `docs/data-model.md §3.10`, `docs/phase2-jira-requirements.md §FR-P2-7`.
 */
// ─── Job kind ────────────────────────────────────────────────────────────────
export const JOB_KINDS = [
    'bulk_jira_push',
    'bulk_jira_pull',
    'bulk_jira_pull_jql',
    'bulk_jira_links_push',
    'bulk_jira_links_pull',
    'bulk_jira_sync_both',
    'hermes_estimate',
    'bulk_hermes_estimate',
    'csv_import_items',
    'csv_import_dictionary',
    'cleanup_sessions',
    'cleanup_audit',
    'cleanup_ai_log',
    'automation_run',
];
export const JobKindSchema = z.enum(JOB_KINDS);
// ─── Job status ──────────────────────────────────────────────────────────────
export const JOB_STATUSES = ['pending', 'running', 'success', 'error', 'cancelled'];
export const JobStatusSchema = z.enum(JOB_STATUSES);
// ─── Job DTO ─────────────────────────────────────────────────────────────────
export const JobSchema = z.object({
    id: z.string().uuid(),
    kind: JobKindSchema,
    status: JobStatusSchema,
    progress: z.number().int().min(0),
    total: z.number().int().min(0),
    spaceId: z.string().uuid().nullable(),
    createdById: z.string().uuid(),
    result: z.unknown().nullable(),
    error: z.string().nullable(),
    startedAt: z.string().nullable(),
    finishedAt: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
// ─── GET /api/jobs/:id response ──────────────────────────────────────────────
export const JobResponseSchema = JobSchema;
// ─── GET /api/jobs?scope=active|recent response ──────────────────────────────
export const JobListResponseSchema = z.object({
    jobs: z.array(JobSchema),
});
// ─── POST /api/jobs/:id/cancel ───────────────────────────────────────────────
export const CancelJobResponseSchema = z.object({
    id: z.string().uuid(),
    status: JobStatusSchema,
});
